import React, { useState } from 'react';
import RcTooltip from 'rc-tooltip';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { IconButton } from '@mui/material';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import SortRoundedIcon from '@mui/icons-material/SortRounded';
import { StyledSortVoiceFilterButton } from './index.style';

const SortVoice = ({ handleChangeFilter, dataFilter, options }) => {
  const { t } = useTranslation();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltipVisibleChange = (visible) => {
    setIsTooltipOpen(visible);
  };

  return (
    <div>
      {isTooltipOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'transparent',
            zIndex: 9999,
            pointerEvents: 'auto',
          }}
          onWheel={(e) => e.preventDefault()}
          onTouchMove={(e) => e.preventDefault()}
        />
      )}
      <RcTooltip
        placement="bottomRight"
        overlay={
          <StyledSortVoiceFilterButton>
            {options.map((item) => (
              <div
                role="button"
                tabIndex={0}
                className={`item ${
                  dataFilter.sortBy === item.value ? 'active' : ''
                }`}
                key={item.value}
                onClick={() => {
                  handleChangeFilter('sortBy', item.value);
                  setIsTooltipOpen(false);
                }}
              >
                <Typography variant="body-14-medium" color={COLOR.darkGray}>
                  {t(item.label)}
                </Typography>
              </div>
            ))}
          </StyledSortVoiceFilterButton>
        }
        trigger={['click']}
        showArrow={false}
        align={{
          offset: [0, 5],
        }}
        onVisibleChange={handleTooltipVisibleChange}
        visible={isTooltipOpen}
        zIndex={10000}
      >
        <IconButton className="filter-btn">
          <SortRoundedIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
          {dataFilter.sortBy && (
            <FiberManualRecordRoundedIcon
              className="circle-btn"
              sx={{ color: COLOR.textPending, fontSize: '16px !important' }}
            />
          )}
        </IconButton>
      </RcTooltip>
    </div>
  );
};

export default SortVoice;
